import { render, staticRenderFns } from "./setVechicleDeptDrawer.vue?vue&type=template&id=348926a3&scoped=true"
import script from "./setVechicleDeptDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./setVechicleDeptDrawer.vue?vue&type=script&setup=true&lang=js"
import style0 from "./setVechicleDeptDrawer.vue?vue&type=style&index=0&id=348926a3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348926a3",
  null
  
)

export default component.exports